import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'

@InputType()
export class UpdateWorkOrderStatusByTasksServiceArgs extends ActionArgs {
  @Field(() => String)
  _id: string
}

export interface IUpdateWorkOrderStatusByTasksService extends IAction<void, UpdateWorkOrderStatusByTasksServiceArgs> {}
